/**
 * NavTabbable.js
 *
 * This script allows for active nav elemetns (i.e. with "focus") to be unfocused when clicking elsewhere on the screen, or when clicking a second time.
 * */

document.addEventListener('DOMContentLoaded', (event) => {
  // Hide the dropdown when clicking the nav button a second time.
  const focusedButtons = []
  const navButtons = document.querySelectorAll('.open-on-focus button') // .link-with-arrow .caratf
  navButtons.forEach(function (item) {
    item.addEventListener('focus', function (e) {
      setTimeout(() => { // Delayed to give the click handler time to run first.
        focusedButtons.push(item)
      }, '100')
    })
    item.addEventListener('blur', function (e) {
      focusedButtons.splice(focusedButtons.indexOf(item), 1)
    })
    item.addEventListener('click', function (e) {
      if (focusedButtons.includes(item)) {
        document.activeElement.blur()
      }
    }, false)
  })
})
